import { render } from "./PatientVitalsDetailsModal.vue?vue&type=template&id=6a93876c"
import script from "./PatientVitalsDetailsModal.vue?vue&type=script&lang=js"
export * from "./PatientVitalsDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__